(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bbm-charm-menu"] && !Shopify.designMode) return;
  try {
    class BBMCharmMenu extends HTMLElement {
 connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('click',event=>{const open=event.target.closest('[data-bbm-open]');const back=event.target.closest('[data-bbm-home]');if(open)this.show(open.dataset.bbmOpen);if(back)this.show('main');});this.closest('header-drawer').querySelector('[data-drawer-close]').addEventListener('click',()=>this.show('main',false));}
 show(name,focus=true){this.toggleAttribute('data-submenu',name!=='main');this.querySelectorAll('[data-bbm-screen]').forEach(panel=>{panel.hidden=panel.dataset.bbmScreen!==name});if(focus){const panel=this.querySelector('[data-bbm-screen="'+name+'"]');const first=panel.querySelector('button,a');if(first)first.focus();}}
}
if(!customElements.get('bbm-charm-menu'))customElements.define('bbm-charm-menu',BBMCharmMenu);
  } catch(e) { console.error(e); }
})();

})();
